<template>
  <div>
    <highcharts :options="{...options}" ref="chart" :key="key"></highcharts>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import stockInit from 'highcharts/modules/stock'
exportingInit(Highcharts)
stockInit(Highcharts)

export default {
  name: 'UiHighCharts',
  data () {
    return {
      key: 0
    }
  },
  props: {
    options: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    options: function (news, old) {
      this.key = Math.random()
    }
  }
}

</script>
